import { DateTime } from 'luxon';
import { ObjectState } from '../../enums/objectState.enum';
import { IConfigObjectBase } from '../../interfaces/config-objects/config-object-base';
import { Guid } from '../guid';
import { ScheduleTaskConfig } from '../schedule-tasks/schedule-task-config';

export class ArchiveConfig implements IConfigObjectBase {
	id: string = Guid();
	name = '';
	description?: string;
	dateCreated: DateTime = DateTime.now();
	lastUpdated: DateTime = DateTime.now();
	objectState?: ObjectState;

	scheduleProps: ScheduleTaskConfig = new ScheduleTaskConfig();
	daysToKeepHistory = 20;
	limit = 1000;

	constructor(init?: Partial<ArchiveConfig>) {
		if (init) {
			Object.assign(this, init);
		}
	}
}
